import React from "react";
import { Link, useLocation } from "react-router-dom";
import { User, ShoppingBag, Heart, MapPin, Settings as SettingsIcon } from "lucide-react";

export default function AccountSidebar() {
  const loc = useLocation();
  const items = [
    { to: "/account/profile", icon: User, label: "Profile", testid: "side-profile" },
    { to: "/account/orders", icon: ShoppingBag, label: "My Orders", testid: "side-orders" },
    { to: "/wishlist", icon: Heart, label: "Wishlist", testid: "side-wishlist" },
    { to: "/account/addresses", icon: MapPin, label: "Saved Addresses", testid: "side-addresses" },
    { to: "/account/settings", icon: SettingsIcon, label: "Account Settings", testid: "side-settings" },
  ];
  return (
    <aside className="bg-white border border-slate-100 rounded-2xl p-3 h-fit sticky top-24">
      {items.map(it => {
        const active = loc.pathname.startsWith(it.to);
        return <Link key={it.to} data-testid={it.testid} to={it.to} className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium ${active?"bg-[#004BCA] text-white":"hover:bg-slate-50"}`}>
          <it.icon size={16}/> {it.label}
        </Link>;
      })}
    </aside>
  );
}
